<template>
  <div class="about-container">
      <SimpleHeader 
        title="關於我們" 
        subtitle="您可以了解一下我們"
      />
    <!-- 核心價值區塊 -->
    <section class="core-values">
      <div class="content-wrapper">
        

        <div class="value-statement" data-aos="fade-left">
          <h3 class="statement">
            <span class="highlight">✨用做一輩子的態度,</span><br>
            <span class="highlight">堅持做好軟件開發這件事✨</span>
          </h3>
        </div>

        <div class="value-cards">
          <div 
            v-for="(value, index) in coreValues"
            :key="index"
            class="value-card"
            data-aos="fade-down"
          >
            <div class="card-icon">
              <img :src="value.icon" :alt="value.title">
            </div>
            <h4 class="card-title" :style="{ color: value.color }">
              {{ value.title }}
            </h4>
            <p class="card-desc">{{ value.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 團隊文化區塊 -->
    <section class="team-culture">
      <div class="content-wrapper">
        <div class="culture-header" data-aos="fade-down">
          <div class="subtitle">我們的團隊</div>
          <h2 class="section-title">🎉把時間花在熱愛的事情上🎉</h2>
        </div>

        <div class="culture-cards">
          <div 
            v-for="(culture, index) in teamCultures"
            :key="index"
            class="culture-card"
            data-aos="fade-up"
          >
            <div class="culture-visual">
              <img :src="culture.image" :alt="culture.title">
            </div>
            <h3 class="culture-title" :style="{ color: culture.color }">
              {{ culture.title }}
            </h3>
            <p class="culture-desc">{{ culture.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      coreValues: [
        {
          icon: require('@/assets/magic.png'),
          title: '包容',
          color: '#60C959',
          description: '打造具有包容性的開發環境，讓每個創意都能自由生長'
        },
        {
          icon: require('@/assets/tips.png'),
          title: '創新',
          color: '#FC6149',
          description: '持續探索前沿技術，推動行業解決方案革新'
        },
        {
          icon: require('@/assets/surgery.png'),
          title: '專注',
          color: '#3F81FE',
          description: '深耕軟件開發領域，專注打造精品應用'
        },
        {
          icon: require('@/assets/privacy.png'),
          title: '安全',
          color: '#FFB15F',
          description: '構建全方位數據安全體系，守護用戶私隱'
        }
      ],
      teamCultures: [
        {
          image: require('@/assets/focus-amico.png'),
          title: '專注',
          color: '#60C959',
          description: '聚焦核心領域，持續優化開發流程與用戶體驗'
        },
        {
          image: require('@/assets/world-cuate.png'),
          title: '熱情',
          color: '#FC6149',
          description: '保持技術熱忱，用代碼創造改變世界的力量'
        },
        {
          image: require('@/assets/world-amico.png'),
          title: '靈活',
          color: '#3F81FE',
          description: '敏捷開發實踐，快速響應市場與技術變革'
        },
        {
          image: require('@/assets/office-pana.png'),
          title: '歸屬',
          color: '#FFB15F',
          description: '營造溫暖團隊氛圍，讓每個成員都能發光發熱'
        }
      ]
    }
  }
}
</script>

<style scoped>
:root {
  --primary-color: #1a2943;
  --secondary-color: #3F81FE;
  --text-dark: #2d3748;
  --text-light: #718096;
  --bg-light: #f8fafc;
}

.about-container {
  background: var(--bg-light);
}

.content-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 核心價值區塊 */
.core-values {
  padding: 4rem 0;
}

.section-title {
  font-size: 4rem;
  color: var(--primary-color);
  margin-bottom: 3rem;
  position: relative;
}

.brand {
  color: var(--secondary-color);
  position: relative;
}

.value-statement {
  text-align: center;
}

.subtitle {
  font-size: 1.75rem;
  color: var(--text-light);
  margin-bottom: 1.5rem;
}

.statement {
  font-size: 3.5rem;
  line-height: 1.2;
}

.highlight {
  background: linear-gradient(45deg, #3F81FE, #60C959);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.value-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  margin-top: 3rem;
}

.value-card {
  background: white;
  border-radius: 1.5rem;
  padding: 2rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease;
}

.value-card:hover {
  transform: translateY(-8px);
}

.card-icon img {
  width: 3.5rem;
  height: 3.5rem;
}

.card-title {
  font-size: 2.25rem;
  margin: 1.5rem 0;
}

.card-desc {
  color: var(--text-light);
  font-size: 1.1rem;
  line-height: 1.6;
}

/* 團隊文化區塊 */
.team-culture {
  padding: 6rem 0;
}

.culture-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  margin-top: 4rem;
}

.culture-card {
  background: white;
  border-radius: 1.5rem;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease;
}

.culture-card:hover {
  transform: translateY(-8px);
}

.culture-visual img {
  width: 100%;
  max-width: 200px;
  height: auto;
  margin-bottom: 1.5rem;
}

.culture-title {
  font-size: 1.75rem;
  margin: 1rem 0;
}

.culture-desc {
  color: var(--text-light);
  font-size: 1rem;
  line-height: 1.6;
}

/* 響應式設計 */
@media (max-width: 1200px) {
  .value-cards,
  .culture-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 2.5rem;
  }

  .statement {
    font-size: 2rem;
  }

  .value-cards,
  .culture-cards {
    grid-template-columns: 1fr;
  }

  .value-card,
  .culture-card {
    padding: 1.5rem;
  }

  .card-title {
    font-size: 1.75rem;
  }
}
</style>